import { useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAPI } from '../services/api';
import AuthContext from '../contexts/auth-context';
import ToastContext from '../contexts/toast-context';

const stringValidation = ({ min = 2, max = 255 } = {}) =>
  Yup.string().min(min, 'Too Short!').max(max, 'Too Long!').required('Required');

const loginSchema = Yup.object().shape({
  username: stringValidation(),
  password: stringValidation(),
});

const LoginPage = () => {
  let api = useAPI();
  const history = useHistory();
  const auth = useContext(AuthContext);
  const { handleError, success } = useContext(ToastContext);
  let redirectPath = new URLSearchParams(history.location.search).get('redirect') ?? '/';

  const login = async (values) => {
    try {
      let response = await api.post('/users/login', values);
      auth.login(response.data.token);
      history.replace(redirectPath);
      success('Logged in!');
    } catch (e) {
      handleError(e);
    }
  };

  const initialValues = {
    username: '',
    password: '',
  };

  const formik = useFormik({
    initialValues,
    onSubmit: login,
    validationSchema: loginSchema,
  });

  if (auth.isLoggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Sign in to your account
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form onSubmit={formik.handleSubmit} className="space-y-6" action="#" method="POST">
            <div>
              <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="username"
                  name="username"
                  type="text"
                  required
                  onChange={formik.handleChange}
                  value={formik.values.username}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Password
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                  autoComplete="current-password"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
